<script lang="ts">
    let { href, text, title }: { href: string; text: string; title?: string } = $props()
    console.log("href", href)
    const isExternal = href.startsWith("http") || href.startsWith("mailto:") || href.startsWith("tel:")
</script>

<a {href} target={isExternal ? "_blank" : "_self"} rel="noopener noreferrer">
    {@html text}
</a>
